import React, { useEffect, useState } from "react";
import "../../styles/Industries.css";
import { RiArrowRightSLine } from "react-icons/ri";
import Education_bg_img from "../../bg_images/I_education_bg_img.png";
import { MdArrowRightAlt } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { HiArrowNarrowRight } from "react-icons/hi";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { MdOutlineKeyboardArrowLeft } from "react-icons/md";

const Servicecards = [
  {
    title: "Enhancing Student Engagement",
    text: " We utilize technology to create more interactive, personalized, and engaging learning experiences to improve student outcomes. ",
  },
  {
    title: " Improving Accessibility and Inclusivity ",
    text: " We leverage technology to create accessible learning environments for all students, regardless of location or learning style. ",
  },
  {
    title: " Modernizing IT Infrastructure ",
    text: " We upgrade outdated systems to create a future-ready, scalable, and secure IT environment for the institution. ",
  },
  {
    title: " Optimizing Operational Efficiency ",
    text: "  We streamline administrative tasks, automate processes, and improve resource allocation with efficient IT solutions. ",
  },
  {
    title: " Staying Ahead of EdTech Trends ",
    text: " Arshil implements innovative technologies and strategies to remain competitive and provide students with cutting-edge learning experiences. ",
  },
];

const Education = () => {
  const navigate = useNavigate();

  const [currentIndex, setCurrentIndex] = useState(0);
      const [visibleServicecards, setVisibleServicecards] = useState(3);
    
      
      useEffect(() => {
        const updateVisibleServicecards = () => {
          if (window.innerWidth <= 768) {
            setVisibleServicecards(1); 
          } else {
            setVisibleServicecards(3); 
          }
        };
    
        updateVisibleServicecards();
        window.addEventListener("resize", updateVisibleServicecards);
        return () =>
          window.removeEventListener("resize", updateVisibleServicecards);
      }, []);
    
      const handleNext = () => {
        if (currentIndex + visibleServicecards < Servicecards.length) {
          setCurrentIndex(currentIndex + 1);
        }
      };
    
      const handlePrev = () => {
        if (currentIndex > 0) {
          setCurrentIndex(currentIndex - 1);
        }
      };


  return (
    <div className="Industries">
      <div
        className="I_sec1"
        style={{ backgroundImage: `url(${Education_bg_img})` }}
      >
        <h5>
          Industries <RiArrowRightSLine className="servrighticon" /> Education
        </h5>
        <h1>
          {" "}
          Empowering the Future of Learning with Innovative EdTech Solutions{" "}
        </h1>
        <p>
          We provide innovative IT solutions to empower higher education
          institutions and EdTech companies to thrive.
        </p>
        <button
          onClick={() => navigate("/services/ApplicationDevelopment")}
          className="S_sec1_btn1"
        >
          Discover Our Services
          <HiArrowNarrowRight className="psec1arrow" />
        </button>
      </div>

      {/* Section 2 */}

      <div className="I_sec2">
        <h2>What We Offer Our Education Customers</h2>
        <section className="I_sec2_cardsContainer">
          <section className="I_sec2_cards">
            <h6>
              <img
                className="I_sec2_icon"
                src="../svg/ED_sec2_icon1.svg"
                alt=""
              />
              Robust Learning Platforms
            </h6>
            <p>
              Scalable and reliable infrastructure for Learning Management
              Systems (LMS), virtual classrooms, and online learning
              environments.
            </p>
          </section>
          <section className="I_sec2_cards">
            <h6>
              <img
                className="I_sec2_icon"
                src="../svg/ED_sec2_icon2.svg"
                alt=""
              />
              Enchanced Digital Learning Experiences
            </h6>
            <p>
              Solutions to create interactive, engaging, and accessible digital
              learning content and delivery methods.
            </p>
          </section>
          <section className="I_sec2_cards">
            <h6>
              <img
                className="I_sec2_icon"
                src="../svg/ED_sec2_icon3.svg"
                alt=""
              />
              Secure and Scalable IT Infrastructure
            </h6>
            <p>
              High-performance and secure IT infrastructure to support growing
              digital demands and protect sensitive student and institutional
              data.
            </p>
          </section>
          <section className="I_sec2_cards">
            <h6>
              <img
                className="I_sec2_icon"
                src="../svg/ED_sec2_icon4.svg"
                alt=""
              />
              Data-Driven Education
            </h6>
            <p>
              Analytics and reporting tools to gain insights into student
              performance, optimize curriculum, and personalize learning
              experiences.
            </p>
          </section>
        </section>
        <button onClick={() => navigate("/contact")} className="I_sec2_btn1">
          Schedule a free consultation
          <HiArrowNarrowRight className="psec1arrow" />
        </button>
      </div>

      {/* Section 3 */}

      <div className="S_carousel-container">
        <h2 className="S_carousel-title">
          Solving the Key Challenges in Higher Education
        </h2>
        <div className="S_carousel-wrapper">
          <button
            className="arrow left-arrow"
            onClick={handlePrev}
            disabled={currentIndex === 0}
          >
            <MdOutlineKeyboardArrowLeft className="S_rightArrow" />
          </button>

          <div className="S_carousel">
            <div
              className="S_carousel-track"
              style={{
                transform: `translateX(-${
                  currentIndex * (100 / visibleServicecards)
                }%)`,
              }}
            >
              {Servicecards.map((card, index) => (
                <div className="S_carousel-card" key={index}>
                  <h3>{card.title}</h3>
                  <div className="underline"></div>
                  <p>{card.text}</p>
                </div>
              ))}
            </div>
          </div>

          <button
            className="arrow right-arrow"
            onClick={handleNext}
            disabled={currentIndex + visibleServicecards >= Servicecards.length}
          >
            <MdOutlineKeyboardArrowRight className="S_rightArrow" />
          </button>
        </div>
      </div>

      {/* Section 4 */}

      <div className="I_sec4">
        <section className="I_sec4_left">
          <h1>Case Study</h1>
          <h6>Transforming Learning and Administration with Technology</h6>
          <p>
            A quasi-federal non-profit organization in the education sector
            struggled with fragmented data systems, inconsistent insights, and
            integration challenges, all of which hindered their mission to
            provide equitable, high-quality education.
          </p>
        </section>
        <section className="I_sec4_right">
          <img
            className="I_sec4_img1"
            src="../images/I_education_img.png"
            alt="education"
          />
        </section>
      </div>

      {/* Section 5  */}

      <div className="I_sec5">
        <section className="I_sec5_left">
          <h4>
            Ready to Transform Your Institution with Education Technology?
          </h4>
          <p>
            Let's discuss how our IT solutions can help you achieve your
            educational goals and create a more impactful learning environment.
          </p>
        </section>
        <section className="I_sec5_right">
          <button onClick={() => navigate("/contact")}>
            Schedule a Free Consultation
            <MdArrowRightAlt className="I_sec5_arrow_right" />
          </button>
        </section>
      </div>
    </div>
  );
};

export default Education;
